import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date | string): string {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatCurrency(amount: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
}

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatValue = (value: number | string): string => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return '0';
  }

  if (numericValue < 1000) {
    return numericValue.toFixed(2).toString();
  }

  if (numericValue < 100000) {
    return `${(numericValue / 1000).toFixed(2).replace(/\.?0+$/, '')}K`;
  }

  return `${(numericValue / 100000).toFixed(2).replace(/\.?0+$/, '')}L`;
};
